export const DICT = {
  en: {
    metaTitle: "Vivan Energia | Solar Installation & AMC Services in Lucknow",
    otherLang: "हिंदी",
    nav: ["Home", "Solar AMC Plans", "Installation Services", "Add-On Services", "Contact Us"],
    callNow: "Call Now",
    siteVisit: "Get Free Site Visit",
    menu: "MENU",
    close: "Close menu",
    hero: {
      lines: ["Solar Se", "Behtar Koi", ["Vikalp", 1], [" Nahi", 0], ["!", 2]],
      sub: "Complete Solar Panel Installation, AMC Maintenance & High-Pressure Panel Cleaning Services in",
      city: "Lucknow",
      cta: "Get Free Site Visit & Customized Quotation",
      badges: ["1-Day Site Finish Guarantee", "Trained Staff", "Zero Complaint Assurance"],
      installFrom: "Installation from",
      amcFrom: "AMC from",
      perMonth: "/ month",
      imgAlt: "Home rooftop with solar panels under bright sunshine",
    },
    marquee: ["Solar Se Behtar Koi Vikalp Nahi", "Clean Energy", "Brighter Tomorrow", "Solar Panels", "Inverters", "Batteries", "Installation & Service", "Lucknow"],
    stats: ["Happy Customers", "Successful Installations", "Years of Experience", "Satisfied AMC Customers"],
    install: {
      num: "02",
      kicker: "Installation Services",
      title: [["Rate list for solar ", 0], ["installation", 1], [" services.", 0]],
      desc: "Transparent per-watt pricing (PW) for Tata, Aavada and other panel brands — choose the package that matches your site structure and material timeline.",
      imgKicker: "One shot · One day",
      imgTitle: "Proper installation, completed in one shot.",
      imgAlt: "Technician installing rooftop solar panels",
      tags: ["Service Package 01", "Service Package 02"],
      titles: ["Normal Structure", "Broad Structure / Delayed Delivery"],
      subs: [
        "1-Day Material Availability with Normal Structure",
        "1-Day Full Material Availability with Broad Structure or Delayed Material Delivery",
      ],
      upto: "Up to 8 kW",
      above: "Above 8 kW",
      tataAavada: "Tata & Aavada Panels",
      tata: "Tata Panels",
      other: "Other Panels",
      warranty: "with warranty inspection",
      perPW: "/ PW",
      important: "Important:",
      noteLabour: "₹500 labour cost extra for all sites.",
      noteOutstation: "Outstation charge beyond Lucknow (up to 100 km). Extra fare applicable.",
    },
    amc: {
      num: "01",
      kicker: "Solar AMC Plans · 2026-27",
      title: [["Vivan ", 0], ["SunCare", 1], [" AMC — your plant at peak, all year.", 0]],
      desc: "Official AMC rate card by capacity and tenure. Pick your plant size and plan — we'll show the exact GST-inclusive amount.",
      plant: "Plant",
      perMo: "/mo",
      badges: ["Save 33%", "Save 28%", "Save 25%", "Save 22%", "Save 20%", "Best Deal"],
      tenureLabels: { yearly: "Yearly", half: "6-Month", monthly: "Monthly" },
      tenureHints: { yearly: "Best value · Advance", half: "Flexible half-yearly", monthly: "Pay as you go" },
      yourPlan: "Your plan",
      months: ["month", "months"],
      gstLine: "18% GST (CGST 9% + SGST 9%)",
      netPayable: "Net payable",
      book: "Book this plan on WhatsApp",
      termsTitle: "Terms & conditions",
      inclusions: {
        yearly: ["4 Water Cleaning Visits (Quarterly)", "2 Full Electrical Audits / yr", "Free Inverter Health Check", "Earthing Pit Resistance Test", "Priority 24 Hr Support"],
        half: ["2 Water Cleaning Visits in 6 Mo", "1 Electrical Audit / 6 Mo", "ACDB/DCDB & Fuse Checkup", "Wiring Loose Connection Test", "48 Hr On-Site Visit"],
        monthly: ["1 Dedicated Water Cleaning", "Basic Visual Reporting", "Inverter Code Check", "Immediate Issue Reporting", "Pay-As-You-Go Reporting"],
      },
      services: [
        { t: "High-Pressure Panel Cleaning", d: "Boosts generation by 15-20% — 4 cleanings a year or 2 in six months." },
        { t: "Electrical & Inverter Safety", d: "ACDB/DCDB box, wire tightness, inverter parameters and MCB checking." },
        { t: "Earthing & LA Inspection", d: "Earthing pits and lightning arrestors checked to prevent electric shock." },
        { t: "Breakdown On-Call Support", d: "Priority engineer visit for faults or shutdowns. Emergency visit ₹500 + 18% GST." },
      ],
      terms: [
        "All subscription rates are exclusive of 18% GST (CGST 9% + SGST 9%).",
        "Annual and 6-month plans require full advance payment at order confirmation.",
        "For cleaning pumps, continuous roof water supply and a 220V power socket are required.",
        "AMC covers service & labour only — damaged spare parts are billed to the customer.",
        "Dismantling & re-installation of a previously wrong installation is charged separately.",
      ],
    },
    addons: {
      num: "03",
      kicker: "Add-On Services",
      title: [["Everything else your rooftop ", 0], ["needs", 1], ["❤", 0]],
      desc: "From sprinkler fitting to earthing and grid connection — clear, fixed add-on rates with no surprises.",
      washTitle: "Panel washing & cleaning",
      washAlt: "Freshly washed solar panels reflecting the sky",
      enquire: "Enquire about an add-on",
      items: [
        { t: "Sprinkler fitting", s: "At time of installation" },
        { t: "Sprinkler fitting", s: "After installation" },
        { t: "Site dismantling", s: "Panels & structure" },
        { t: "Grid connection", s: "ACDB, DCDB" },
        { t: "L/A change", s: "Lightning arrestor" },
        { t: "Routing", s: "Cable routing" },
        { t: "Structure installation", s: "With grouting only" },
        { t: "Earthing only", s: "Per earthing" },
        { t: "Visit charge", s: "Site visit" },
      ],
    },
    gallery: {
      num: "04",
      kicker: "Our Work & Reviews",
      title: [["On rooftops across ", 0], ["Lucknow", 1], ["❤", 0]],
      desc: "A look at our installations and service visits. Send us photos of your site — we love showing real work.",
      captions: ["Rooftop solar installation", "Home with solar under the sun", "After a high-pressure wash", "Installation day", "Panel cleaning in progress", "Maintenance visit"],
      cta: "Send us your site photos & review on WhatsApp",
      reviewsTitle: "What customers say",
      sample: "Sample",
      empty: "Reviews coming soon — be our first! Send your feedback on WhatsApp.",
      reviewCta: "Write a review on WhatsApp",
      ownerToggle: "Owner: add real site photos",
      ownerTitle: "Upload real installation photos",
      codePh: "Owner passcode",
      capEnLabel: "Caption (English)",
      capHiLabel: "Caption (Hindi, optional)",
      chooseLabel: "Choose photos (JPG/PNG/WEBP, max 5 MB each)",
      submitPhotos: "Upload to gallery",
      uploadOk: "Uploaded — your real photos now lead the gallery.",
      uploadErr: "Upload failed — check the passcode, file types/sizes and try again.",
      revOwnerToggle: "Owner: manage reviews",
      revName: "Customer name",
      revArea: "Area (e.g. Dubagga, Lucknow)",
      revRating: "Rating",
      revText: "Review text",
      revAdd: "Add review",
      revDelete: "Delete",
      revOk: "Review added — it's live below.",
      revDelOk: "Review deleted.",
      revErr: "Failed — check the passcode and fields.",
      visitNote: "True auto-sending needs WhatsApp's paid Business API — instead, one day after each logged visit the request is auto-prepared (and auto-emailed when the customer's email is known); you tap once to send it on WhatsApp.",
    },
    visits: {
      ownerToggle: "Owner: AMC visit tracker",
      title: "Log a finished AMC visit — the review request auto-prepares next day",
      custName: "Customer name",
      custPhone: "Customer WhatsApp number",
      custEmail: "Customer email (optional — auto thank-you email)",
      logVisit: "Log visit",
      loggedOk: "Visit logged — the review request will be ready tomorrow.",
      recent: "Recent visits",
      sendWa: "Send review request",
      upcoming: "Today & upcoming",
      past: "Past visits",
      morningNote: "Every morning at 8:00 AM (IST) you get an email listing today's visits, with a one-tap WhatsApp reminder of the full list.",
    },
    benefits: {
      num: "05",
      kicker: "Benefits & Complementary Services",
      title: [["Complete peace of mind, ", 0], ["included", 2], ["❤", 0]],
      imgAlt: "Vivan technician working on solar panels",
      items: [
        "Proper installation completed in one shot.",
        "1-day site finish guarantee.",
        "1-year rectification guarantee service only (free materials provided for any damage during installation).",
        "Free site visits for structure / material quotes.",
        "Free site running visits after meter confirmation.",
        "Full responsibility for returning extra materials.",
        "Free labour support for material loading / unloading.",
        "Trained, educated, well-behaved staff with zero complaint assurance.",
        "Complete peace of mind.",
      ],
    },
    ratecard: {
      num: "06",
      kicker: "Rate Card",
      title: [["The complete ", 0], ["rate card", 1], [", at a glance.", 0]],
      desc: "All AMC subscription rates are exclusive of 18% GST. Download the official rate card to share with family or your society.",
      th: ["Capacity", "Yearly (12 mo)", "6-Month", "Monthly", "Yearly net incl. GST"],
      capCol: "Capacity",
      pkgCol: "Package",
      pkgNames: ["Package 01", "Package 02"],
      tataCol: "Tata / Aavada",
      otherCol: "Other panels",
      dlPdf: "Download AMC Rate Card (PDF)",
      dlPoster: "Download Installation Rate List",
    },
    contact: {
      num: "06",
      kicker: "Contact Us",
      title: [["Get a free site visit & ", 0], ["customized quotation", 1], ["❤", 0]],
      desc: "Just WhatsApp us or call — we'll visit your site, check the structure and share an exact quote.",
      proprietor: "Proprietor",
      phoneLabel: "Phone / Mobile",
      emailLabel: "Email",
      addressLabel: "Address",
      gstinLabel: "GSTIN",
      waBtn: "WhatsApp +91 9616356356",
      namePh: "Your name",
      phonePh: "Mobile number",
      locPh: "Location / area in Lucknow",
      msgPh: "Anything we should know? (optional)",
      services: ["Free Site Visit & Quotation", "Solar Installation", "AMC Plan", "Panel Washing & Cleaning", "Add-On Service", "Emergency / Breakdown Visit"],
      capExtra: ["Above 10 kW", "Not sure"],
      submit: "Send enquiry on WhatsApp",
      note: "Opens WhatsApp with your details pre-filled — just hit send.",
      photosLabel: "Site photos (optional, up to 3)",
      photosHint: "JPG, PNG or WEBP · up to 5 MB each · photos reach us with your enquiry",
      uploading: "Uploading photos…",
    },
    footer: {
      desc: "Solar installation, AMC maintenance and high-pressure panel cleaning services in Lucknow.",
      regards: "Regards,",
      role: "(Proprietor)",
      explore: "Explore",
      reach: "Reach us",
      strip: ["Solar Panels", "Inverters", "Batteries", "Installation & Service"],
      tagline: "Clean Energy · Green Planet · Bright Future",
      aiNote: "AI answers by Bijli Bot — powered by Gemini",
      rights: "All rights reserved.",
    },
    widget: {
      headerAI: "Ask AI — instant answers",
      headerWA: "Chat with us on WhatsApp",
      powered: "Powered by Gemini · Saved on WhatsApp",
      tabs: ["Ask AI", "WhatsApp"],
      welcome: "Namaste! I'm Bijli Bot — Vivan Energia's AI assistant. Ask me anything about our AMC plans, installation rates or panel cleaning. (Aap Hindi ya English — jaise aapko theek lage!)",
      suggestions: ["3 kW AMC ka kya rate hai?", "Installation charges per watt?", "Panel washing ka price?"],
      quick: [
        "I'd like a Free Site Visit & Customized Quotation.",
        "I want to know about your AMC plans.",
        "I need panel washing & cleaning.",
        "I need a solar installation quote.",
      ],
      ph: "Ask about prices, AMC, cleaning…",
      estOpen: "Not sure what you need? Estimate my solar savings",
      estBack: "Back to chat",
      estTitle: "3 quick questions — AI does the rest:",
      estBill: "Monthly electricity bill (₹)",
      estArea: "Roof area",
      estFloor: "Floors",
      estHas: "Already have solar?",
      estYes: "Yes — needs maintenance",
      estNo: "No",
      estSubmit: "Estimate my savings",
      estBusy: "Crunching the sun numbers…",
      estWa: "Get exact quote on WhatsApp",
      estWaMsg: "Hi Vivan Energia, I got my solar estimate from your website and want a free site visit.",
      phBill: "e.g. 3000",
      phArea: "e.g. 40×30 ft",
      phFloor: "e.g. 2",
    },
  },
  hi: {
    metaTitle: "विवन एनर्जिया | लखनऊ में सोलर इंस्टॉलेशन व AMC सेवाएँ",
    otherLang: "English",
    nav: ["होम", "सोलर AMC प्लान", "इंस्टॉलेशन सेवाएँ", "ऐड-ऑन सेवाएँ", "संपर्क करें"],
    callNow: "कॉल करें",
    siteVisit: "फ्री साइट विज़िट पाएँ",
    menu: "मेनू",
    close: "मेनू बंद करें",
    hero: {
      lines: ["सोलर से", "बेहतर कोई", ["विकल्प", 1], [" नहीं", 0], ["!", 2]],
      sub: "लखनऊ में संपूर्ण सोलर पैनल इंस्टॉलेशन, AMC रखरखाव व हाई-प्रेशर पैनल क्लीनिंग सेवाएँ —",
      city: "लखनऊ",
      cta: "फ्री साइट विज़िट और कस्टमाइज़्ड कोटेशन पाएँ",
      badges: ["1-दिन में साइट तैयार गारंटी", "प्रशिक्षित स्टाफ", "ज़ीरो शिकायत का भरोसा"],
      installFrom: "इंस्टॉलेशन शुरू",
      amcFrom: "AMC शुरू",
      perMonth: "/ माह",
      imgAlt: "धूप में सोलर पैनलों वाली घर की छत",
    },
    marquee: ["सोलर से बेहतर कोई विकल्प नहीं", "क्लीन एनर्जी", "ब्राइटर टुमॉरो", "सोलर पैनल", "इन्वर्टर", "बैटरी", "इंस्टॉलेशन व सर्विस", "लखनऊ"],
    stats: ["खुश ग्राहक", "सफल इंस्टॉलेशन", "साल का अनुभव", "संतुष्ट AMC ग्राहक"],
    install: {
      num: "02",
      kicker: "इंस्टॉलेशन सेवाएँ",
      title: [["सोलर इंस्टॉलेशन सेवाओं की ", 0], ["रेट लिस्ट", 1], ["।", 0]],
      desc: "टाटा, आवादा और अन्य पैनल ब्रांड्स के लिए पारदर्शी प्रति-वॉट (PW) क़ीमत — अपनी साइट के स्ट्रक्चर और मटेरियल समय के अनुसार पैकेज चुनें।",
      imgKicker: "एक ही बार में · एक दिन में",
      imgTitle: "पक्का इंस्टॉलेशन, एक ही बार में पूरा।",
      imgAlt: "छत पर सोलर पैनल लगाते तकनीशियन",
      tags: ["सर्विस पैकेज 01", "सर्विस पैकेज 02"],
      titles: ["नॉर्मल स्ट्रक्चर", "ब्रॉड स्ट्रक्चर / देर से डिलीवरी"],
      subs: [
        "1-दिन में मटेरियल उपलब्ध, नॉर्मल स्ट्रक्चर",
        "1-दिन में पूरा मटेरियल, ब्रॉड स्ट्रक्चर या देर से मटेरियल डिलीवरी",
      ],
      upto: "8 kW तक",
      above: "8 kW से अधिक",
      tataAavada: "टाटा व आवादा पैनल",
      tata: "टाटा पैनल",
      other: "अन्य पैनल",
      warranty: "वारंटी निरीक्षण के साथ",
      perPW: "/ PW",
      important: "ध्यान दें:",
      noteLabour: "सभी साइट्स पर ₹500 लेबर कॉस्ट अतिरिक्त।",
      noteOutstation: "लखनऊ से बाहर (100 किमी तक) आउटस्टेशन चार्ज लागू। अतिरिक्त किराया लागू।",
    },
    amc: {
      num: "01",
      kicker: "सोलर AMC प्लान · 2026-27",
      title: [["विवन ", 0], ["सनकेयर", 1], [" AMC — आपका प्लांट साल-भर बेस्ट परफॉर्मेंस में।", 0]],
      desc: "क्षमता और अवधि के अनुसार आधिकारिक AMC रेट कार्ड। अपना प्लांट साइज़ और प्लान चुनें — GST सहित सटीक राशि दिखाएँगे।",
      plant: "प्लांट",
      perMo: "/माह",
      badges: ["33% बचत", "28% बचत", "25% बचत", "22% बचत", "20% बचत", "बेस्ट डील"],
      tenureLabels: { yearly: "सालाना", half: "छमाही", monthly: "मासिक" },
      tenureHints: { yearly: "सबसे फ़ायदेमंद · एडवांस", half: "लचीली छमाही", monthly: "जैसे इस्तेमाल, वैसे भुगतान" },
      yourPlan: "आपका प्लान",
      months: ["महीना", "महीने"],
      gstLine: "18% GST (CGST 9% + SGST 9%)",
      netPayable: "कुल देय",
      book: "यह प्लान WhatsApp पर बुक करें",
      termsTitle: "नियम व शर्तें",
      inclusions: {
        yearly: ["4 बार पानी से क्लीनिंग विज़िट (तिमाही)", "साल में 2 पूर्ण इलेक्ट्रिकल ऑडिट", "फ्री इन्वर्टर हेल्थ चेक", "अर्थिंग पिट रेज़िस्टेंस टेस्ट", "24 घंटे प्राथमिकता सपोर्ट"],
        half: ["6 महीने में 2 क्लीनिंग विज़िट", "छमाही में 1 इलेक्ट्रिकल ऑडिट", "ACDB/DCDB व फ्यूज़ जाँच", "वायरिंग लूज़ कनेक्शन टेस्ट", "48 घंटे में ऑन-साइट विज़िट"],
        monthly: ["1 समर्पित पानी क्लीनिंग", "बुनियादी विज़ुअल रिपोर्टिंग", "इन्वर्टर कोड चेक", "तुरंत समस्या रिपोर्टिंग", "पे-एज़-यू-गो रिपोर्टिंग"],
      },
      services: [
        { t: "हाई-प्रेशर पैनल क्लीनिंग", d: "पैनल की जनरेशन 15-20% बढ़ाती है — साल में 4 या छमाही में 2 क्लीनिंग।" },
        { t: "इलेक्ट्रिकल व इन्वर्टर सेफ्टी", d: "ACDB/DCDB बॉक्स, वायर टाइटनेस, इन्वर्टर पैरामीटर व MCB जाँच।" },
        { t: "अर्थिंग व LA निरीक्षण", d: "अर्थिंग पिट व लाइटनिंग अरेस्टर जाँच — बिजली की चपट से बचाव।" },
        { t: "ब्रेकडाउन ऑन-कॉल सपोर्ट", d: "खराबी या शटडाउन पर इंजीनियर की प्राथमिकता विज़िट। इमरजेंसी विज़िट ₹500 + 18% GST।" },
      ],
      terms: [
        "सभी सदस्यता दरें 18% GST (CGST 9% + SGST 9%) से मुक्त हैं।",
        "सालाना और छमाही प्लान में ऑर्डर कन्फ़र्म होने पर पूरा भुगतान अग्रिम आवश्यक।",
        "क्लीनिंग पंप के लिए छत पर लगातार पानी की सप्लाई और 220V पावर सॉकेट ज़रूरी।",
        "AMC केवल सर्विस व लेबर कवर करता है — खराब स्पेयर पार्ट्स का खर्चा ग्राहक वहन करेगा।",
        "पहले से गलत इंस्टॉलेशन की डिसमेंटलिंग व री-इंस्टॉलेशन अलग से चार्ज होगा।",
      ],
    },
    addons: {
      num: "03",
      kicker: "ऐड-ऑन सेवाएँ",
      title: [["छत की हर दूसरी ", 0], ["ज़रूरत", 1], [" का हल।", 0]],
      desc: "स्प्रिंकलर फिटिंग से अर्थिंग और ग्रिड कनेक्शन तक — साफ़, तय ऐड-ऑन रेट, कोई छुपा खर्च नहीं।",
      washTitle: "पैनल वॉशिंग व क्लीनिंग",
      washAlt: "धुलाई के बाद आसमान दर्शाते साफ़ सोलर पैनल",
      enquire: "ऐड-ऑन के बारे में पूछें",
      items: [
        { t: "स्प्रिंकलर फिटिंग", s: "इंस्टॉलेशन के समय" },
        { t: "स्प्रिंकलर फिटिंग", s: "इंस्टॉलेशन के बाद" },
        { t: "साइट डिसमेंटलिंग", s: "पैनल व स्ट्रक्चर" },
        { t: "ग्रिड कनेक्शन", s: "ACDB, DCDB" },
        { t: "L/A बदलाव", s: "लाइटनिंग अरेस्टर" },
        { t: "रूटिंग", s: "केबल रूटिंग" },
        { t: "स्ट्रक्चर इंस्टॉलेशन", s: "केवल ग्राउटिंग के साथ" },
        { t: "केवल अर्थिंग", s: "प्रति अर्थिंग" },
        { t: "विज़िट चार्ज", s: "साइट विज़िट" },
      ],
    },
    gallery: {
      num: "04",
      kicker: "हमारा काम व रिव्यू",
      title: [["पूरे ", 0], ["लखनऊ", 1], [" की छतों पर।", 0]],
      desc: "हमारे इंस्टॉलेशन और सर्विस विज़िट की एक झलक। अपनी साइट की तस्वीरें भेजें — हमें असली काम दिखाना पसंद है।",
      captions: ["रूफटॉप सोलर इंस्टॉलेशन", "धूप में सोलर वाला घर", "हाई-प्रेशर धुलाई के बाद", "इंस्टॉलेशन का दिन", "पैनल क्लीनिंग जारी", "मेंटेनेंस विज़िट"],
      cta: "अपनी साइट की तस्वीरें व रिव्यू WhatsApp करें",
      reviewsTitle: "ग्राहक क्या कहते हैं",
      sample: "सैंपल",
      empty: "रिव्यू जल्द आ रहे हैं — पहले आप बनिए! अपना फीडबैक WhatsApp करें।",
      reviewCta: "WhatsApp पर रिव्यू लिखें",
      ownerToggle: "मालिक: असली साइट फ़ोटो जोड़ें",
      ownerTitle: "असली इंस्टॉलेशन फ़ोटो अपलोड करें",
      codePh: "मालिक पासकोड",
      capEnLabel: "कैप्शन (English)",
      capHiLabel: "कैप्शन (हिंदी, वैकल्पिक)",
      chooseLabel: "फ़ोटो चुनें (JPG/PNG/WEBP, अधिकतम 5 MB)",
      submitPhotos: "गैलरी में अपलोड करें",
      uploadOk: "अपलोड हो गया — आपकी असली तस्वीरें अब गैलरी में सबसे आगे हैं।",
      uploadErr: "अपलोड फ़ेल — पासकोड, फ़ाइल टाइप/साइज़ जाँचकर फिर कोशिश करें।",
      revOwnerToggle: "मालिक: रिव्यू मैनेज करें",
      revName: "ग्राहक का नाम",
      revArea: "इलाका (जैसे दुबग्गा, लखनऊ)",
      revRating: "रेटिंग",
      revText: "रिव्यू का टेक्स्ट",
      revAdd: "रिव्यू जोड़ें",
      revDelete: "हटाएँ",
      revOk: "रिव्यू जुड़ गया — नीचे दिख रहा है।",
      revDelOk: "रिव्यू हटा दिया गया।",
      revErr: "फ़ेल — पासकोड और जानकारी जाँचें।",
      visitNote: "सीधा ऑटो-भेजना WhatsApp की पेड बिज़नेस API से ही संभव है — इसलिए विज़िट लॉग होने के एक दिन बाद रिक्वेस्ट अपने आप तैयार हो जाती है (ईमेल पता हो तो मेल भी अपने आप जाता है); आप एक टैप में WhatsApp पर भेज दीजिए।",
    },
    visits: {
      ownerToggle: "मालिक: AMC विज़िट ट्रैकर",
      title: "पूरा हुआ AMC विज़िट लॉग करें — रिव्यू रिक्वेस्ट अगले दिन अपने आप तैयार",
      custName: "ग्राहक का नाम",
      custPhone: "ग्राहक का WhatsApp नंबर",
      custEmail: "ग्राहक का ईमेल (वैकल्पिक — धन्यवाद ईमेल अपने आप जाएगा)",
      logVisit: "विज़िट लॉग करें",
      loggedOk: "विज़िट लॉग हो गई — रिव्यू रिक्वेस्ट कल तैयार होगी।",
      recent: "हाल की विज़िट",
      sendWa: "रिव्यू रिक्वेस्ट भेजें",
      upcoming: "आज और आगे की विज़िट",
      past: "पुरानी विज़िट",
      morningNote: "हर सुबह 8:00 बजे (IST) आपको ईमेल मिलता है जिसमें आज की विज़िट की पूरी सूची और एक टैप WhatsApp रिमाइंडर होता है।",
    },
    benefits: {
      num: "05",
      kicker: "फ़ायदे व मुफ़्त सेवाएँ",
      title: [["पूरा सुकून, ", 0], ["सब शामिल", 2], ["।", 0]],
      imgAlt: "सोलर पैनल पर काम करता विवन तकनीशियन",
      items: [
        "इंस्टॉलेशन एक ही बार में सही से पूरा।",
        "1-दिन में साइट पूरी होने की गारंटी।",
        "1 साल की रेक्टिफिकेशन गारंटी (केवल सर्विस; इंस्टॉलेशन के दौरान किसी भी नुक़सान के लिए फ्री मटेरियल)।",
        "स्ट्रक्चर / मटेरियल कोट के लिए फ्री साइट विज़िट।",
        "मीटर कन्फ़र्मेशन के बाद फ्री फ़ॉलो-अप विज़िट।",
        "अतिरिक्त मटेरियल वापसी की पूरी ज़िम्मेदारी।",
        "मटेरियल लोडिंग / अनलोडिंग में फ्री लेबर सहयोग।",
        "प्रशिक्षित, सुशिक्षित व विनम्र स्टाफ — ज़ीरो शिकायत का भरोसा।",
        "पूरा सुकून।",
      ],
    },
    ratecard: {
      num: "06",
      kicker: "रेट कार्ड",
      title: [["पूरा ", 0], ["रेट कार्ड", 1], [" — एक नज़र में।", 0]],
      desc: "सभी AMC सदस्यता दरें 18% GST से मुक्त। आधिकारिक रेट कार्ड डाउनलोड कर परिवार या सोसाइटी को भेजें।",
      th: ["क्षमता", "सालाना (12 माह)", "छमाही", "मासिक", "सालाना GST सहित"],
      capCol: "क्षमता",
      pkgCol: "पैकेज",
      pkgNames: ["पैकेज 01", "पैकेज 02"],
      tataCol: "टाटा / आवादा",
      otherCol: "अन्य पैनल",
      dlPdf: "AMC रेट कार्ड डाउनलोड (PDF)",
      dlPoster: "इंस्टॉलेशन रेट लिस्ट डाउनलोड",
    },
    contact: {
      num: "06",
      kicker: "संपर्क करें",
      title: [["फ्री साइट विज़िट और ", 0], ["कस्टमाइज़्ड कोटेशन", 1], [" पाएँ।", 0]],
      desc: "बस WhatsApp करें या कॉल करें — हम आपकी साइट देखकर सही कोटेशन देंगे।",
      proprietor: "संचालक",
      phoneLabel: "फ़ोन / मोबाइल",
      emailLabel: "ईमेल",
      addressLabel: "पता",
      gstinLabel: "GSTIN",
      waBtn: "WhatsApp +91 9616356356",
      namePh: "आपका नाम",
      phonePh: "मोबाइल नंबर",
      locPh: "लखनऊ में लोकेशन / इलाका",
      msgPh: "हमें और कुछ बताना है? (वैकल्पिक)",
      services: ["फ्री साइट विज़िट व कोटेशन", "सोलर इंस्टॉलेशन", "AMC प्लान", "पैनल वॉशिंग व क्लीनिंग", "ऐड-ऑन सर्विस", "इमरजेंसी / ब्रेकडाउन विज़िट"],
      capExtra: ["10 kW से अधिक", "पता नहीं"],
      submit: "WhatsApp पर जानकारी भेजें",
      note: "आपकी जानकारी के साथ WhatsApp खुलेगा — बस भेज दें।",
      photosLabel: "साइट की तस्वीरें (वैकल्पिक, अधिकतम 3)",
      photosHint: "JPG, PNG या WEBP · प्रत्येक 5 MB तक · तस्वीरें आपकी जानकारी के साथ हम तक पहुँचती हैं",
      uploading: "फ़ोटो अपलोड हो रही हैं…",
    },
    footer: {
      desc: "लखनऊ में सोलर इंस्टॉलेशन, AMC रखरखाव और हाई-प्रेशर पैनल क्लीनिंग सेवाएँ।",
      regards: "सादर,",
      role: "(संचालक)",
      explore: "साइट देखें",
      reach: "संपर्क",
      strip: ["सोलर पैनल", "इन्वर्टर", "बैटरी", "इंस्टॉलेशन व सर्विस"],
      tagline: "क्लीन एनर्जी · ग्रीन प्लैनेट · ब्राइट फ्यूचर",
      aiNote: "AI जवाब — बिजली बॉट, Gemini द्वारा संचालित",
      rights: "सर्वाधिकार सुरक्षित।",
    },
    widget: {
      headerAI: "AI से पूछें — तुरंत जवाब",
      headerWA: "WhatsApp पर बात करें",
      powered: "Gemini द्वारा संचालित · WhatsApp पर सुरक्षित",
      tabs: ["AI से पूछें", "WhatsApp"],
      welcome: "नमस्ते! मैं बिजली बॉट हूँ — Vivan Energia का AI सहायक। AMC प्लान, इंस्टॉलेशन रेट या पैनल क्लीनिंग — कुछ भी पूछिए। (हिंदी या English, जैसे आपको ठीक लगे!)",
      suggestions: ["3 kW AMC का रेट क्या है?", "प्रति वॉट इंस्टॉलेशन चार्ज?", "पैनल वॉशिंग का रेट?"],
      quick: [
        "फ्री साइट विज़िट व कस्टमाइज़्ड कोटेशन चाहिए।",
        "AMC प्लान जानना चाहता/चाहती हूँ।",
        "पैनल वॉशिंग व क्लीनिंग चाहिए।",
        "सोलर इंस्टॉलेशन का कोटेशन चाहिए।",
      ],
      ph: "रेट, AMC, क्लीनिंग के बारे में पूछें…",
      estOpen: "साइज़ नहीं पता? मेरी सोलर बचत आज़माएँ",
      estBack: "चैट पर वापस",
      estTitle: "सिर्फ़ 3 सवाल — बाक़ी AI संभालेगा:",
      estBill: "महीने का बिजली बिल (₹)",
      estArea: "छत का एरिया",
      estFloor: "मंज़िलें",
      estHas: "पहले से सोलर है?",
      estYes: "हाँ — रखरखाव चाहिए",
      estNo: "नहीं",
      estSubmit: "मेरी बचत बताइए",
      estBusy: "सूरज से हिसाब लगा रहे हैं…",
      estWa: "WhatsApp पर सटीक कोटेशन पाएँ",
      estWaMsg: "नमस्ते Vivan Energia, मुझे आपकी वेबसाइट पर सोलर अनुमान मिला और मैं फ्री साइट विज़िट चाहता/चाहती हूँ।",
      phBill: "जैसे 3000",
      phArea: "जैसे 40×30 फ़ीट",
      phFloor: "जैसे 2",
    },
  },
};
